import React from "react";
import Select, { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FormControl, Typography } from "@mui/material";

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <ArrowDropDownIcon />
        </components.DropdownIndicator>
    );
};

const MultiSelect = ({
    formik,
    options,
    name,
    value,
    label,
    onchange,
    disabledOptions = [],
    isNested = false,
    required,
    defaultLabel = "Select",
    width = "100%",
    mb = "20px",
    isColored = true,
    ...props
}) => {
    const colorOptions = ["#FF69B4", "#FFA500", "#FF0000"];

    const getColorForOption = (optionValue) => {
        if (isNested) {
            const index = options.findIndex((option) =>
                option.options?.some((opt) => opt.value === optionValue)
            );
            return colorOptions[index % colorOptions.length];
        }
        const index = options.findIndex((option) => option.value === optionValue);
        return colorOptions[index % colorOptions.length];
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: "none",
            borderRadius: "10px",
            minHeight: "50px",
            maxHeight: "50px",
            overflow: "hidden",
            backgroundColor: "#F1F4FA",
            boxShadow: state.isFocused ? "none" : provided.boxShadow,
            "&:hover": {
                border: "none",
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            maxHeight: "50px",
            overflow: "auto",
            padding: "2px 8px",
            "&::-webkit-scrollbar": {
                width: "4px",
                height: "4px",
            },
            "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#888",
                borderRadius: "4px",
            },
        }),
        multiValue: (styles, { data }) => ({
            ...styles,
            // backgroundColor: getColorForOption(data.value) || "gray",
            backgroundColor: isColored
                ? getColorForOption(data.value) || "gray"
                : "gray",
            borderRadius: "5px",
            margin: "2px",
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            color: "#fff",
            fontSize: "12px",
            padding: "2px 6px",
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: "#fff",
            ":hover": {
                backgroundColor: "rgba(0,0,0,0.1)",
                color: "#fff",
            },
        }),
        placeholder: (provided) => ({
            ...provided,
            color: "black",
            fontSize: "13px",
            padding: "0 0 0 3px",
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10,
        }),
    };

    return (
        <FormControl
            variant="standard"
            sx={{ width: "100%", marginBottom: mb }}
        >
            {label && (

                <Typography variant="h7" component="div" gutterBottom>


                    {label}
                </Typography>
            )}

            <Select
                components={{
                    DropdownIndicator,
                    IndicatorSeparator: () => null,
                }}
                placeholder={defaultLabel}
                options={options}
                isMulti
                value={value}
                onChange={onchange}
                isOptionDisabled={(option) => disabledOptions.includes(option.value)}
                styles={customStyles}
                {...props}
            />
            {formik.touched[name] && formik.errors[name] ? (
                <Typography
                    variant="caption"
                    sx={{
                        color: "red",
                        fontSize: "12px",
                        fontWeight: "400",
                        mt: "5px",
                        ml: "15px",
                    }}
                >
                    {formik.errors[name]}
                </Typography>
            ) : null}
        </FormControl>
    );
};

export default MultiSelect;